import { validateNavixyApiKey } from "../API/Config";

const cache = new Map();

const checkNavixyKey = (key) => {
  const trimmed = (key || "").trim();
  if (!trimmed) return Promise.resolve(null);

  if (!cache.has(trimmed)) {
    const pending = validateNavixyApiKey(trimmed).then((status) => {
      if (status === "ambiguous") cache.delete(trimmed);
      return status;
    });
    cache.set(trimmed, pending);
  }

  return cache.get(trimmed);
};

const navixyApiKeysRule = {
  validator: async (_, value) => {
    const keys = Array.isArray(value) ? value : [];
    const results = await Promise.all(keys.map(checkNavixyKey));
    if (results.includes("invalid")) {
      throw new Error(
        "This Navixy API key is invalid. Remove it or enter a valid key.",
      );
    }
  },
};

const navixyApiKeyFieldProps = {
  validateItem: checkNavixyKey,
  rules: [navixyApiKeysRule],
  validateTrigger: "onBlur",
};

export { checkNavixyKey, navixyApiKeysRule, navixyApiKeyFieldProps };
